<app-widget-option [categories]="['LAYERS']" [label]="'STACKED'" [limitedTo]="['line']">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="widgetLayers.layer(current).stacked" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-widget-option>